<script setup lang="ts">
import { ref, onMounted } from 'vue'

const STORAGE_KEY = 'cookie_consent'
const visible = ref(false)

onMounted(() => {
  const consent = localStorage.getItem(STORAGE_KEY)
  if (!consent) {
    visible.value = true
  }
})

function accept(): void {
  localStorage.setItem(STORAGE_KEY, 'accepted')
  visible.value = false
}

function reject(): void {
  localStorage.setItem(STORAGE_KEY, 'rejected')
  visible.value = false
}
</script>

<template>
  <Transition
    enter-active-class="transition duration-300 ease-out"
    enter-from-class="translate-y-full opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-full opacity-0"
  >
    <div
      v-if="visible"
      class="fixed bottom-0 inset-x-0 z-50 p-4"
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
    >
      <div class="max-w-4xl mx-auto bg-white dark:bg-surface-800 rounded-xl shadow-2xl border border-surface-200 dark:border-surface-700 p-4 sm:p-6">
        <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div class="flex-1">
            <h2 id="cookie-consent-title" class="text-sm font-semibold text-surface-900 dark:text-white">We use cookies</h2>
            <p id="cookie-consent-description" class="mt-1 text-sm text-surface-600 dark:text-surface-400">
              We use cookies to improve your experience and analyze site traffic. By accepting, you agree to our
              <router-link to="/legal/cookies" class="text-primary-600 dark:text-primary-400 hover:underline">Cookie Policy</router-link>.
            </p>
          </div>
          <div class="flex gap-3 flex-shrink-0">
            <button
              type="button"
              class="px-4 py-2 text-sm font-medium rounded-lg border border-surface-300 dark:border-surface-600 text-surface-700 dark:text-surface-300 hover:bg-surface-50 dark:hover:bg-surface-700 transition-colors"
              @click="reject"
            >
              Reject
            </button>
            <button
              type="button"
              class="px-4 py-2 text-sm font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700 transition-colors"
              @click="accept"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>
